import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appPhoneNumberFormatter]'
})
export class PhoneNumberFormatterDirective {

  @Input('appPhoneFormatter')
  formatTypes: 'dot' | 'dash' | 'format4' | 'default' | undefined;

  constructor(private el: ElementRef, private control: NgControl) { }

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    const input = event.target;
    const clear = input.value.replace(/\D+/g, '').substring(0, 10);

    let formatted = '';
    if (this.formatTypes === 'dot') {
      const match = clear.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
      //dot format
      if (match[1]) formatted = `${match[1]}`;
      if (match[2]) formatted += `.${match[2]}`;
      if (match[3]) formatted += `.${match[3]}`;

    } else if (this.formatTypes === 'dash') {
      const match = clear.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
      //dash format
      if (match[1]) formatted = `${match[1]}`;
      if (match[2]) formatted += `-${match[2]}`;
      if (match[3]) formatted += `-${match[3]}`;
    }//+ format
      else if (this.formatTypes === 'format4') {
        const match2 = clear.match(/^(\d{1})(\d{0,3})(\d{0,3})(\d{0,3})$/);
        if (match2[1]) formatted = `+${match2[1]}`;
        if (match2[2]) formatted += ` ${match2[2]}`;
        if (match2[3]) formatted += ` ${match2[3]}`;
        if (match2[4]) formatted += ` ${match2[4]}`;
    }
    else {
      const match = clear.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
      //common Used
      if (match[1]) {
        formatted = `(${match[1]}`;
      }
      if (match[2]) {
        formatted += match[2].length === 3 ? `) ${match[2]}` : match[2];
      }
      if (match[3]) {
        formatted += `-${match[3]}`;
      }
    }
    this.control.control?.setValue(formatted);
  }

}
